import admin from './admin'
import auth from './auth'
import publicLink from './public'

const links = {
  admin,
  public: publicLink,
  auth,
}

export default links
